export default {
  save: 'Guardar',
  start: 'Empezar',
  confirm: 'Confirmar',
  disable: 'Desactivar'
}
